import { ConfigProvider, DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import locale from 'antd/es/locale/ru_RU';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
// Плагин для настройки первого дня недели
import localeData from 'dayjs/plugin/localeData';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
// Замените на нужную локаль
import weekday from 'dayjs/plugin/weekday';
import React, { FC } from 'react';

// Подключаем плагины
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.extend(timezone);

// Устанавливаем первый день недели
dayjs.locale('ru', {
  weekStart: 1, // Понедельник как первый день недели
});

export const RangePicker: FC<RangePickerProps> = (props) => {
  return (
    <ConfigProvider locale={locale}>
      <DatePicker.RangePicker {...props} />
    </ConfigProvider>
  );
};
